<!--
 * @Author: qnghe
 * @Date: 2025-01-20 14:15:37
 * @LastEditTime: 2026-07-22 09:27:17
 * @Description: 年计划 动态分类
-->
<template>
  <div class="year-next atb-flex atb-flex-column">
    <header class="header atb-flex atb-flex-items-center">
      <div class='year-title'>
        <h2 class="title-text">{{this.summaryData.resWkName ? this.summaryData.title + ' / ' + this.summaryData.resWkName: ''}}</h2>
        <span class="save-status">{{saveStatus}}</span>
      </div>
    </header>
    <div class='container search-and-content atb-content-bg atb-flex atb-flex-column' id="year-wrap">
      <div class='search'>
        <el-form v-if="isShowSearch" :inline="true" :model="searchParam" class="atb-input search-input" @keyup.enter.native="getList" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="类别">
             <el-autocomplete v-model="searchParam.WorkItemCategory" :fetch-suggestions="queryCategory" placeholder="类别" clearable></el-autocomplete>
          </el-form-item>
          <el-form-item class="flex-form-item" label="分类">
            <el-select v-model="searchParam.WorkClassify" placeholder="分类" clearable>
              <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="状态">
            <el-select v-model="searchParam.Status" placeholder="状态" clearable>
              <el-option v-for="item in completeList" :key="item.id" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="关键字">
            <el-input v-model="searchParam.KeyWord" placeholder="工作项目" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="function atb-flex">
          <el-form :inline="true" class="atb-input model">
            <el-form-item>
              <el-radio-group v-model="model" @change="changeModel">
                <el-radio label="1">完整模式</el-radio>
                <el-radio label="2">计划模式</el-radio>
                <el-radio label="3">半年总结</el-radio>
                <el-radio label="4">全年总结</el-radio>
                <el-radio label="5">汇报模式</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="atb-input">
            <el-form-item v-if="editStatus == 'edit' && status !== 10">
              <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus == 'edit'&& (status ===0||status ===30)">
              <el-button :disabled="pending" type="primary" @click="copyPreviousYearPlan">复制</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus === 'edit'">
              <el-button type="primary"  @click="submitHandle">提交</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit' || editStatus==='manage'">
              <el-button type="import" plain @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'&& (status ===0||status ===30)">
              <el-upload 
                ref="file"
                :http-request="uploadFile"
                :multiple="false"
                :show-file-list='false'
              >
              <el-button plain type="import">导入</el-button>
            </el-upload>
            </el-form-item>
            <el-form-item v-if="editStatus==='edit'&& (status ===0||status ===30)">
              <el-button plain type="import" @click="downloadTemplate">下载模板</el-button>
            </el-form-item>
            <el-form-item v-if="this.editStatus==='approve'">
              <el-button type="primary" @click="showApprove=true">通过</el-button>
            </el-form-item>
            <el-form-item v-if="this.editStatus==='approve'">
              <el-button type="refuse" @click="showCompleteApprove=true">驳回</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="import" @click="expandRowContentAll">{{expandRowContentAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
            <el-form-item v-if="editStatus === 'edit' && (status ===0 || status ===30)">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <el-button type="import" plain class="menu-button">
                  批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item command="a">开始日期</el-dropdown-item>
                  <el-dropdown-item command="b">最终完成日期</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
            <el-form-item v-if="editStatus==='manage'">
              <el-button type="downloadTemplate" plain @click="preciseExport">精确导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="open" @click="expandSearch">
          <span>筛选</span>
          <i :class="[isShowSearch ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
        </div>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.yearTable, tableColumn)">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class='atb-table header-table edit-table border-table disable-ellipsis'
          border='full'
          height='100%'
          auto-resize
          resizable
          row-key="id"
          :data="tableData"
          ref="yearTable"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          @cell-click="expandRowContent"
          :edit-rules="validRules"
          :spanMethod="mergeMethod"
          :tree-config="{indent: 0, iconOpen: 'icon-arrow-up-bold', iconClose: 'icon-arrow-down-bold-copy', expandAll: true, }"
          :checkbox-config="{visibleMethod: checkboxVisible, checkField: 'isChecked'}"
        >
          <!-- :merge-cells="mergeCells" -->
          <!-- :spanMethod="mergeMethod" -->
          <vxe-table-column field="tree" width='0' max-width="0" tree-node>
            <template #default="{row, rowIndex}">
              <div v-if="row.isClassifyRow" class='row-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                <div class="classify-wrap">
                  <span class="classify-name" @click.stop="expandThisRow(row)">
                    <span v-if="row.children.length === 0" class="empty-children-expand-icon">
                      <i :class="[row.emptyChildrenExpand ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy']" @click.stop="emptyChildrenExpandHandler(row)"></i>
                    </span>
                    <span>{{ row.classifyName }}</span>
                  </span>
                  <i v-throttle v-if='row.type == 1 && (status === 0 || status === 30) && editStatus === "edit"' @click.stop="addRow(row, rowIndex)" class="icon-add"></i>
                </div>
                <span class="add-btn" v-throttle v-if='row.type == 1 && (status === 0 || status === 30) && editStatus === "edit"' @click.stop='addRow(row, rowIndex)'>新增</span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column type='checkbox' width='40' align='center'></vxe-table-column>
          <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
            <template #default="scope">
              <span>{{seqMethod(scope)}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" min-width="60" title="类别" :edit-render="{name: 'ElAutocomplete', enabled: enabledWorkItemCategory, autofocus: '.el-textarea__inner'}">
             <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}</div>
            </template>
            <template #edit="{ row }">
             <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="queryCategory" >
               <template slot-scope="{ item }">
                <el-tooltip
                  class="item"
                  effect='dark'
                  :content="item.value"
                  placement="right-start"
                >
                 <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                </el-tooltip>
               </template>
             </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" min-width="100" :width="model == 5 ? null : 150" :edit-render="{ enabled: enabledExcep, autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.workItemContent" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
            <template #default="scope">
              <div :class="[scope.row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{scope.row.workItemContent}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullTarget" min-width="100" :width="model == 4 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFullTarget}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="resWkName" width="80" title="责任人" :edit-render="{autofocus: '.el-textarea__inner', enabled: false}">
            <template #edit="{ row }"><el-input type='textarea' autosize v-model="row.resWkName"></el-input></template>
          </vxe-table-column>
          <vxe-table-column field="weight" width="80" title="权重(%)" :edit-render="{autofocus: '.el-input__inner', enabled: enabledExcep}">
            <template #edit="{ row }">
              <el-autocomplete v-model.number="row.weight" :fetch-suggestions="querySearchWeight" :min="1" @change="validateWeight(row)" oninput="value=value.replace(/[^\.\d]/g,'')"></el-autocomplete>
            </template>
            <template #default="{ row }">
              <span>{{row.weight}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="startDate" title="开始日期" width="120" :edit-render="{autofocus: '.el-input__inner', enabled: enabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.startDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="最终完成日期" width="120" :edit-render="{autofocus: '.el-input__inner', enabled: enabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfTarget" min-width="120" :width="model == 5 ? null : 250" title="上半年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledHalfTarget}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfSummary" min-width="120" :width="model == 5 ? null : 250" title="上半年总结" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFhs}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishFullTarget" min-width="100" :width="model == 5 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFinishFullTarget}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.finishFullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.finishFullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullSummary" min-width="100" :width="model == 5 ? null : 250" title="全年总结" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFs}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" min-width="100" title="备注" :edit-render="{autofocus: '.el-textarea__inner', enabled: enabledFullTarget || enabledHalfTarget || enabledFinishFullTarget || enabledFs || enabledFhs}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.remark" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="提交状态" min-width="150" fixed="right">
            <template #default="{ row }">
              <el-tag
                v-if='row.status === 0'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 10'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 20'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 30'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 35'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 40'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 50'
                type="close"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 55'
                type="complete"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 60'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 70'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-popover
                  v-if="row.status === 30 || row.status === 50 || row.status === 70" 
                  placement="top"
                  width="300"
                  trigger="hover"
                  popper-class="reason"
                  :visible-arrow='false'>
                    <div>
                      {{row.approveReason || '无'}}
                    </div>
                      <span slot="reference" class='program-tip reason'>
                      <i class='icon-hint'></i>
                    </span>
                  </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column field="operation" title="操作" width="180" fixed="right" class-name='operation'>
            <template #default="{row, rowIndex, $rowIndex}">
              <div v-if='!row.isClassifyRow && [1, 2].includes(row.type) && (row.status === 0 || row.status === 30) && row.workClassify !== 30 && row.workClassify !== 40 && editStatus == "edit"'>
                <el-tooltip class='item' effect='dark' content='复制' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-throttle class='icon-copy' @click.stop='copyData(row, $rowIndex).then(()=>{ editActived({row:row, rowIndex: $rowIndex})})'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-throttle class='icon-close delete' @click.stop='deleteData(row, $rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='切换分类' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-if="row.id && !isTempId(row.id)" class='icon-move' @click.stop='moveClassify(row, $rowIndex)'></i>
                </el-tooltip>
              </div>
              <div v-if='row.status === 20 || row.status==40 || row.status==50 || row.status==70'>
                <el-tooltip v-if="editStatus==='edit'" class='item' effect='dark' content='提交' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i class='icon-send' @click.stop='commitComplete(row, $rowIndex)'></i>
                </el-tooltip>
                <el-tooltip v-if='row.workClassify === 30 && row.workClassify === 40' class='item' effect='dark' content='删除' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i class='icon-close delete' @click.stop='deleteData(row, $rowIndex)'></i>
                </el-tooltip>
              </div>
              <div v-if='(row.status === 35 || row.status === 55) && editStatus==="approve" && editStatus == "approve"'>
                <el-tooltip class='item' effect='dark' content='通过' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i class='icon-definite' @click.stop='complete(row, $rowIndex, "access")'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='驳回' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i class='icon-overruled' @click.stop='complete(row, $rowIndex, "refuse")'></i>
                </el-tooltip>
                <el-tooltip v-if='row.workClassify === 30 && row.workClassify === 40' class='item' effect='dark' content='删除' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i class='icon-close delete' @click.stop='deleteData(row, $rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <context-menu :data="tableColumn" :selector="`.year-next .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in moveClassifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" class="submit-limit-tip" :visible.sync="showSubmitTip" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <i class="submit-limit-icon el-icon-warning"></i>
        <h2>您的年计划暂不能提交！</h2>
        <div class="submit-tip-wrap">
          <div class="submit-tip-content">
            <span class="submit-tip-item" v-for="(item, index) in submitLimitMsg" :key="index">
              <span v-if="index === 0">您的</span>
              <span>{{ item.classifyName }}</span><span>需≥</span><span>{{ item.minLimit }}条</span>
              <span v-if="index !== submitLimitMsg.length - 1">；</span>
              <span v-else>。</span>
            </span>
          </div>
        </div>
        <div class="submit-tip-text">需您补充完整后再次提交！</div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-confirm" type="primary" @click="showSubmitTip = false">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要提交吗?</h2>
        <p>{{tipMsg}}</p>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审批意见" :visible.sync="showApprove" width="500px" @close="closeApprove" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 5 }"
        placeholder="审批通过原因可不填"
        v-model="approveReason">
      </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="审批意见" :visible.sync="showCompleteApprove" width="500px" @close="closeApprove" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 5 }"
        placeholder="审批驳回原因必须填写"
        v-model="rejectReason">
      </el-input>
        <fast-approve @approveText="rejectText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCompleteApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :command="dialogContent.command"
          :completeList="completeList"
          :selectData="selecterData"
          :editData="editData"
          :classifyConfigs="classifyConfigs"
          @submitSuccess="copyLast()"
        ></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import XEUtils from 'xe-utils'
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin'

export default {
  name: 'YearPlanDetailNext',
  mixins: [routeMixin],
  components: {
    CopyWork: () => import('../year-plan/CopyWork.vue'),
    batchEdit: () => import('../year-plan/batchEdit.vue'),
    ExportNext: () => import('../year-plan/ExportNext.vue'),
  },
  data() {
    const workItemContent = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('工作项目不能为空')
      }
    }
    const fullTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('全年目标不能为空')
      }
    }
    const weight = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('权重不能为空')
      }
    }
    const startDate = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('开始日期不能为空')
      }
      else {
        if (row.finishDate && (row.status === 0 || row.status === 30)) {
          if (XEUtils.timestamp(cellValue) > XEUtils.timestamp(row.finishDate)) {
            return new Error('开始日期不能大于最终完成日期')
          }
        }
      }
    }
    const finishDate = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('最终完成日期不能为空')
      } else {
        if (row.startDate && (row.status === 0 || row.status === 30)) {
          if (XEUtils.timestamp(cellValue) < XEUtils.timestamp(row.startDate)) {
            return new Error('最终完成日期不能小于开始日期')
          }
        }
      }
    }
    const firstHalfTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30 || row.status === 20 || row.status === 50)) {
        return new Error('上半年目标不能为空')
      }
    }
    const finishFullTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('全年目标不能为空')
      }
    }
    const firstHalfSummary = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 20 || row.status === 50) && (this.status != 0 && this.status != 30)) {
        return new Error('上半年总结不能为空')
      }
    }
    const fullSummary = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 40 || row.status === 70)) {
        return new Error('全年总结不能为空')
      }
    }
    return {
      fromPage: '',
      workId: '',
      status: null,
      editStatus: null,
      msgId: null,
      childIds: null,
      isShowSearch: false,
      model: '1',
      saveStatus: '',
      newRow: { // 新增行，默认数据
        workId: "",
        workClassify: 0,
        workItemNo: "",
        workItemCategory: "",
        workItemContent: "",
        resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : "",
        resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : "",
        fullTarget: "",
        weight: 1,
        startDate: "",
        finishDate: "",
        firstHalfTarget: "",
        firstHalfSummary: "",
        finishFullTarget: "",
        fullSummary: "",
        completeStatus: 0,
        reason: "",
        schedule: "",
        status: 0,
        remark: "",
        parentId: null,
        expandRowContentFlag: false,
        children: null,
        isChecked: false,
        type: -1,
      },
      classifyConfigs: [],
      tableData: [],
      mergeCells: [],
      tableColumn: [],

      categoryList: [],

      editData: {},
      summaryData: {},
      searchParam: {
        WorkItemCategory: null,
        WorkClassify: null,
        KeyWord: null,
        CompleteStatus: null
      },
      
      expandRowContentAllFlag: false,

      downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/yearnext/年计划导入模版.xlsx",

      isCollapse: false,
      showCollapse: false,

      enabled: true,
      enabledFullTarget: true,
      enabledHalfTarget: true,
      enabledWorkItemCategory: true,
      enabledExcep: true,
      enabledFhs: true,
      enabledFs: true,
      enabledFinishFullTarget: true,

      pending:false,
      autoSaving: false, //是否在自动保存中
      isPreventSave: false, //是否阻止了自动保存

      
      dialogContent: {},

      showHandle: false,
      moveClassifyList: [
        {label: '重要KPI', value: 0},
        {label: '业务工作', value: 10},
        {label: '其他工作', value: 60},
      ],
      classify: '',

      showSubmit: false,
      tipMsg: '',
      validRules: {
        workItemContent: [
          { required: true, validator: workItemContent, message: '工作项目不能为空' }
        ],
        fullTarget: [
          { required: true, validator: fullTarget, message: '全年目标不能为空' }
        ],
        weight: [
          { required: true, validator: weight, message: '权重不能为空' }
        ],
        startDate: [
          { required: true, validator: startDate, message: '开始时间不能为空' }
        ],
        finishDate: [
          { required: true, validator: finishDate, message: '最终完成时间不能为空' }
        ],
        firstHalfTarget: [
          { required: true, validator: firstHalfTarget, message: '上半年目标不能为空' }
        ],
        finishFullTarget: [
          { required: true, validator: finishFullTarget, message: '全年目标不能为空' }
        ],
        firstHalfSummary: [
          { required: true, validator: firstHalfSummary, message: '上半年总结不能为空' }
        ],
        fullSummary: [
          { required: true, validator: fullSummary, message: '全年总结不能为空' }
        ],
        resWkName: [
          { required: true }
        ]
      },

      showApprove: false,
      showCompleteApprove: false,
      rejectReason: '',
      approveReason: '',
      approveRow: null,

      submitLimitMsg: [],
      showSubmitTip: false, // 提示不满足最小条数的分类

      minLimits: [],
      noMinLimits: [],
    }
  },
  computed: {
    tableColumnLength() {
      return this.tableColumn.filter(val => val.visible !== false).length;
    }
  },
  watch: {
    showSubmit:{
      handler: function (newValue) {
        if (newValue) {
          const tableDataFlat = this.getAllChildrenRow(this.tableData)
          const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
          if (data.length === 0 || data.some(t => t.status == 0 || t.status == 30)) {
            this.tipMsg = "计划提交到领导审批后不能更改";
          } else {
            this.tipMsg = "总结提交到领导审批";
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    getMinLimit() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'YearClassifyMINLimit' }).then((res) => {
        const minLimits = [];
        const data = (res.data && res.data.rows) || [];
        data.forEach(item => {
          const classify = this.classifyList.find(c => c.value == item.itemKey);
          minLimits.push({
            workClassify: classify.value,
            minLimit: item.itemValue,
            classifyName: classify.label,
            sort: item.sort
          })
        })
        minLimits.sort((a, b) => a.sort - b.sort);

        this.minLimits = minLimits;
      });
    },
    getNoMinLimitByDept() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'NoYearClassifyMINLimit' }).then((res) => {
        const data = (res.data && res.data.rows) || [];
        this.noMinLimits = data;
      });
    },
    flatToTree(flatData) {
      const map = new Map();
      const tree = [];
      flatData.forEach(item => {
        map.set(item.id, { ...item, children: [] });
      });
      flatData.forEach(item => {
        const parent = map.get(item.parentId);
        if (parent) {
          parent.children.push(map.get(item.id));
        } else {
          tree.push(map.get(item.id));
        }
      });
      return tree;
    },
    treeToFlat(treeData) {
      const flatData = [];
      function traverse(node) {
        flatData.push({ ...node, children: undefined });
        if (node.children) {
          node.children.forEach(child => traverse(child));
        }
      }
      treeData.forEach(root => traverse(root));
      return flatData;
    },
    getAllChildrenRow() {
      const data = [];
      this.tableData.forEach(row => {
        const children = row.children || [];
        data.push(...children)
      })
      return data;
    },
    seqMethod({row, seq}) {
      let seqNumber = 0;
      let treeSeq = seq && typeof seq === 'string' ? seq.split('.') : (row.seq || '').split('.');
      seqNumber = treeSeq[1];
      return seqNumber || row.workItemNo;
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    async getWorkItemStatus() {
      await this.$ajax.get(this.$api.common.getDict, {ItemType: 'YearWorkItemStatus'}).then((res) => {
        if (res.code === 0) {
          this.completeList = res.data && res.data.rows || [];
        }
      });
    },
    getStatusName(val) {
      const obj = this.completeList.find(t => t.itemValue == val);
      return obj ? obj.itemDesc : '';
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
        const item = res.data || [];
        // this.filterCategory 全局方法
        this.categoryList = this.filterCategory(item.filter(t => t.status === 1));
      });
    },
    queryCategory(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      var results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return (categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    getList() {
      // 保存当前状态
      const expandRecords = this.$refs.yearTable ? this.$refs.yearTable.getTreeExpandRecords() : [];
      const tableScroll = this.$refs.yearTable ? this.$refs.yearTable.getScroll() : {};

      let param = Object.assign({WorkId: this.workId,  WorkItemIds: this.childIds}, this.searchParam, this.page)
      return this.$ajax.get(this.$api.year.yearWorkDetail.list + '?' + qs.stringify(param, { indices: false })).then((res) => {
        if (res.data) {
          this.classifyConfigs = res.data.classifys;
          const classifyMap = {};
          const classifyRows = [];
          this.classifyList = [];

          const rows = res.data.details || [];

          this.classifyConfigs.forEach(classifyItem => {
            classifyMap[classifyItem.workClassify] = classifyItem;
            const classifyRow = {
              ...classifyItem,
              parentId: null,
              isClassifyRow: true,
              isChecked: false,
              children: [],
              emptyChildrenExpand: true,
            };
            this.classifyList.push({
              label: classifyItem.classifyName,
              value: classifyItem.workClassify,
            })
            const childs = rows.filter(row => row.workClassify === classifyItem.workClassify);
            childs.forEach(child => {
              child.expandRowContentFlag = false;
              child.isChecked = false;
              child.parentId = classifyItem.id;
              child.type = classifyItem.type;
            })
            classifyRow.children = childs || [];
            classifyRows.push(classifyRow);
          });
          
          this.tableData = classifyRows;
          this.summaryData = res.data.plan;
          this.status = this.summaryData.status;
          // this.setMerge();
          if (res.data.details.length > 0) {
            // this.setMerge();
            setTimeout(() => {
              this.setPosition();
            }, 50);
          }

          // 恢复状态
          this.$nextTick(() => {
            const ids = expandRecords.map(item => item.id);
            const expandRows = this.tableData.filter(item => {
              return item.isClassifyRow && ids.includes(item.id);
            })
            this.$refs.yearTable.setTreeExpand(expandRows, true).then(() => {
              this.$refs.yearTable.scrollTo(tableScroll.scrollLeft, tableScroll.scrollTop);
            });
          });
        }
      }).catch(() => {
        this.status = null;
      }).finally(() => {
        this.expandAll();
      });

    },
    mergeMethod({row}) {
      if (row.isClassifyRow) {
        return {rowspan: 1, colspan: this.tableColumnLength}
      } else{
        return {rowspan: 1, colspan: 1}
      }
    },
    setMerge() {
      this.mergeCells = [];
      this.tableData.forEach((item) => {
        if (item.isClassifyRow) {
          this.mergeCells.push({row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength});
        }
      })
    },
    collapse(el, column) {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        column.forEach(val => {
          if (val.title == "操作" || val.title == "提交状态") {
            val.visible = false;
          }
        });
        el && el.refreshColumn();
        this.setPosition("reset");
      } else {
        column.filter(val => val.title == "操作" || val.title == "提交状态").forEach(val => {
          val.visible = true;
        });
        el && el.refreshColumn();
        setTimeout(() => {
          this.setPosition();
        }, 50)
      }
    },
    setPosition(reset) {
      this.showCollapse = true;
      if (!document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
        this.showCollapse = false;
        return false;
      }
      if (!reset && document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth === 0) {
        this.showCollapse = false;
        return false;
      }
      if (reset) {
        document.getElementsByClassName("collapse")[0].style.right = 0;       
      } else {
        try {
          const left = document.getElementsByClassName("vxe-table--fixed-right-wrapper")[0].offsetWidth;
          const height = document.getElementsByClassName('table-content')[0].offsetHeight;
          document.getElementsByClassName("collapse")[0].style.top = (height / 2 - 15)  + "px";
          document.getElementsByClassName("collapse")[0].style.right = left + "px";
        } catch(e) {
          throw e;
        }
      }
    },
    changeModel(e, submit) {
      const arr = this.tableColumn.filter(val => val.property !== undefined);
      
      let list = [];
      switch (e) {
        case "1":
          list = [];
          if(localStorage.getItem("year_table_herder") && this.editStatus === "edit" && !submit){
            let cache = JSON.parse(localStorage.getItem("year_table_herder"));
            this.tableColumn.forEach(v => {
              cache.forEach(t => {
                if (v.title == t.title){
                  v.visible = t.visible;
                }
              })
            });
          }else {
            this.tableColumn.forEach(val => {
              val.visible = true;
            });
          }
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          }, 50);
          break;
        case "2":
          list = ["tree", "workItemCategory", "workItemContent","fullTarget", "weight" ,"startDate","finishDate","firstHalfTarget", "finishFullTarget","status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "3":
          list = ["tree", "workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate","firstHalfTarget", "firstHalfSummary", "status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "4":
          list = ["tree", "workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate", "finishFullTarget", "fullSummary", "status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "5":
          list = ["tree", "workItemContent", "firstHalfTarget", "firstHalfSummary","finishFullTarget","fullSummary"];
          this.isCollapse = false;
          this.showCollapse = false;
          break;
      }
      if (list.length) {
        arr.forEach(val => {
          if (list.indexOf(val.property) !== -1){
            val.visible = true;
          }else {
            val.visible = false;
          }
        });
      }
      this.$refs.yearTable.refreshColumn();
    },

    copyPreviousYearPlan() {
      this.dialogContent = {
        title: '复制年计划',
        componentName: 'CopyWork',
        width: "950px"
      }
      this.editData.workId = this.workId;
      this.editData.year = this.summaryData.year ? this.summaryData.year - 1 : 0;
      this.$refs.addSyncDialog.show();
    },
    async copyData(row) {
      const $table = this.$refs.yearTable;
      const parentRow = this.tableData.find(item => item.id === row.parentId)
      if (parentRow.children.length >= parentRow.limit) {
        this.$message.error(`最多可添加${parentRow.limit}条数据`);
        return false;
      }
      const newRecord = _.cloneDeep(row);
      delete newRecord._X_ID;
      newRecord.status = 0;
      
      newRecord.id = 'temp_' + Date.now();
      newRecord.seq = `0.${parentRow.children.length + 1}`
      parentRow.children.push(newRecord);

      let scrollInfo = $table.getScroll();
      await $table.loadData(this.tableData);
      $table.setActiveRow(newRecord);
      this.$nextTick(() => {
        $table.scrollTo(0, scrollInfo.scrollTop);
      });
    },
    submitHandle() {
      this.submitLimitMsg = [];
      
      const currentDept = (this.summaryData.department || '').split('\\\\').join('\\');
      let currentDeptNoLimits = [];
      this.noMinLimits.forEach(item => {
        if (currentDept.includes(item.itemKey)) {
          let vals = (item.itemValue || '').split(/,|，/);
          vals = vals.filter(v => v !== '');
          if (vals.length > 0) currentDeptNoLimits.push(...vals);
        }
      })
      currentDeptNoLimits = [...new Set(currentDeptNoLimits)];
      
      this.minLimits.forEach(item => {
        const classifyData = this.tableData.find(row => row.isClassifyRow && row.workClassify == item.workClassify);
        if ((item.minLimit || item.minLimit === 0) && classifyData && classifyData.children.length < item.minLimit && !currentDeptNoLimits.includes(item.workClassify + '')) {
          this.submitLimitMsg.push(item);
        }
      });

      if (['0', '30', 0, 30].includes(this.status) && this.submitLimitMsg.length > 0) {
        this.showSubmitTip = true;
      } else {
        this.showSubmit = true;
      }
    },
    submit() {
      const validateObj = {};
      this.showSubmit = false;
      this.showSubmitTip = false;
      this.expandAll();
      // this.setMerge();
      this.changeModel("1", "submit");
      this.model = "1";
      this.$nextTick(async () => {
        let check = this.$refs.yearTable.getCheckboxRecords();
        const checkData = check.filter(val => val.workId !== undefined);
        const tableDataFlat = this.getAllChildrenRow(this.tableData);
        const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
        if (data.length && data.filter(t => t.source === 0 || t.source === 3).every(t => t.status == 0 || t.status == 30 || (t.status == 20 && t.source === 3))) {
          validateObj.value = data.filter(t => t.source === 0 || t.source === 3);
        } else {
          if (checkData.length) {
            validateObj.value = checkData;
          } else {
            validateObj.value = data;
          }
        }
        
        const $table = this.$refs.yearTable
        const errMap = await $table.validate(validateObj.value).catch(errMap => errMap)
        if (errMap) {
          const msgList = []
          Object.values(errMap).forEach(errList => {
            errList.forEach(params => {
              const { rules } = params
              rules.forEach(rule => {
                // msgList.push(`第 ${rowIndex + 1} 行 ${column.title} 校验错误：${rule.message}`)
                msgList.push(`${rule.message}`)
              })
            })
          })
          this.$message({
            type: 'error',
            message: msgList.join()
          })
        } else {
          if (data.length === 0) {
            return this.$message.success('计划内容未填写...');
          } else if (data.filter(t => t.source === 0).length && data.filter(t => t.source === 0).every(t => t.status == 10)) {
            return this.$message.warning('计划已提交');
          } else if (data.filter(t => t.source === 0).length && data.filter(t => t.source === 0).every(t => t.status == 0 || t.status == 30)) {
            this.$ajax.put(this.$api.year.yearWorkDetail.submit, { workId: this.workId, status: 10, msgId: this.msgId }, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
              if (res.code == 0) {
                this.$message.success('提交成功');
                this.getList();
              } else {
                this.$message.error(res.message);
              }
            })
          } else if (checkData.length === 0) {
            if (data.every(t => t.status == 35 || t.status == 55)) {
              return this.$message.warning('总结已提交');
            } else if (this.childIds) {
              this.idList = data.map(val => {
                const { id } = val;
                return { id: id, workId: this.workId };
              });
              if (data.every(t => t.status == 20 || t.status == 50)) {
                const list = this.idList.map(val => {
                  return { ...val, status: 35, msgId: this.msgId };
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('提交成功');
                  this.getList();
                });
              } else if (data.every(t => t.status == 40 || t.status == 70)) {
                const list = this.idList.map(val => {
                  return { ...val, status: 55, msgId: this.msgId };
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                  this.$message.success('提交成功');
                  this.getList();
                });
              } else {
                return this.$message.error('任务状态不一致...');
              }
            } else {
              this.idList = data.map(val => {
                const { id } = val;
                return { id: id, workId: this.workId };
              });
              if (data.every(t => t.status == 20 || t.status == 50)) {
                const list = this.idList.map(val => {
                  return { ...val, status: 35, msgId: this.msgId };
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                  if (res.code == 0) {
                    this.$message.success('提交成功');
                    this.getList();
                  } else {
                    this.$message.error(res.message);
                  }
                });
              } else if (data.every(t => t.status == 40 || t.status == 70)) {
                const list = this.idList.map(val => {
                  return { ...val, status: 55, msgId: this.msgId };
                })
                this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                  if (res.code == 0) {
                    this.$message.success('提交成功');
                    this.getList();
                  } else {
                    this.$message.error(res.message);
                  }
                });
              } else if (data.every(t => t.status === 60)) {
                this.$message.warning('任务已完成，您无须重复提交。');
              } else {
                return this.$message.error('任务状态不一致...');
              }
            }
          } else {
            if (checkData.every(t => t.status == 35 || t.status == 55)) {
              return this.$message.warning('总结已提交');
            } else if (checkData.every(t => t.status == 20 || t.status == 50)) {
              let data = check.filter(val => val.workId !== undefined);
              this.idList = data.map(val => {
                const { id } = val;
                return { id: id, workId: this.workId };
              });
              const list = this.idList.map(val => {
                return { ...val, status: 35, msgId: this.msgId };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                if (res.code == 0) {
                  this.$message.success('提交成功');
                  this.getList();
                } else {
                  this.$message.error(res.message);
                }
              });
            } else if (checkData.every(t => t.status == 40 || t.status == 70)) {
              let data = check.filter(val => val.workId !== undefined);
              this.idList = data.map(val => {
                const { id } = val;
                return { id: id, workId: this.workId };
              });
              const list = this.idList.map(val => {
                return { ...val, status: 55, msgId: this.msgId };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then((res) => {
                if (res.code == 0) {
                  this.$message.success('提交成功');
                  this.getList();
                } else {
                  this.$message.error(res.message);
                }
              });
            } else if (checkData.every(t => t.status === 60)) {
              this.$message.warning('任务已完成，您无须重复提交。');
            } else {
              return this.$message.error('任务状态不一致...');
            }
          }
        }
      });
    },

    updateStatus(doWhat) {
      if (doWhat === "access") {
        this.showApprove = false;
      } else {
        this.showCompleteApprove = false;
        if (typeof (this.rejectReason) === "undefined" || this.rejectReason === null || this.rejectReason.split(" ").join("").length === 0 || this.rejectReason.replace(/\s+/g, "").length === 0) {
          this.$message.error("必须填写驳回原因");
          return false;
        }
      }
      let check = this.$refs.yearTable.getCheckboxRecords();
      const checkData = check.filter(val => val.workId !== undefined);
      const tableDataFlat = this.getAllChildrenRow(this.tableData);
      const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
      if (data.filter(t => t.source === 0).length && data.filter(t => t.source === 0).every(t => t.status == 10)) {
        //员工提交工作项目 待审批状态
        if (doWhat == "access") {
          this.$ajax.put(this.$api.year.yearWorkDetail.submit, { workId: this.workId, status: 20, msgId: this.msgId, approveReason: this.approveReason }).then(() => {
            this.$message.success('审批成功');
            this.editStatus = '';
            this.getList();
          });
        } else {
          this.$ajax.put(this.$api.year.yearWorkDetail.submit, { workId: this.workId, status: 30, msgId: this.msgId, approveReason: this.rejectReason }).then(() => {
            this.$message.success('审批成功');
            this.editStatus = '';
            this.getList();
          });
        }
      } else if (checkData.length === 0) {
        if (this.approveRow) {
          const obj = {};
          if (doWhat === "access") {
            if (this.approveRow.status === 35) {
              obj.status = 40;
            } else {
              obj.status = 60;
            }
          } else {
            if (this.approveRow.status === 35) {
              obj.status = 50;
            } else {
              obj.status = 70;
            }
          }
          const paramArr = [{
            id: this.approveRow.id,
            status: obj.status,
            workId: this.workId,
            msgId: this.msgId,
            approveReason: doWhat === "access" ? this.approveReason : this.rejectReason
          }]
          this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, paramArr).then((res) => {
            if (res.code == 0) {
              this.$message.success('审批成功');
              this.getList().then(() => {
                const tableDataFlat = this.getAllChildrenRow(this.tableData);
                const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
                this.editStatus = this.judgeCompleteStatus(data) ? "" : 'approve';
              });
              if (obj.status === 40 || obj.status === 60) {
                this.toWorkscorePage({ status: obj.status });
              }
            }
          });
        } else if (this.childIds) {
          if (data.some(t => t.status == 35)) {
            this.idList = data.filter(t => t.status === 35).map(val => {
              const { id } = val;
              return { id: id, workId: this.workId };
            });
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              const list = this.idList.map(val => {
                return { ...val, status: 40, msgId: this.msgId, approveReason: this.approveReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
                this.toWorkscorePage({ status: 40 });
              });
            } else {
              //工作状态变更已驳回状态
              const list = this.idList.map(val => {
                return { ...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else if (data.some(t => t.status == 55)) {
            this.idList = data.filter(t => t.status === 55).map(val => {
              const { id } = val;
              return { id: id, workId: this.workId };
            });
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              const list = this.idList.map(val => {
                return { ...val, status: 60, msgId: this.msgId, approveReason: this.approveReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = ''
                this.getList();
                this.toWorkscorePage({ status: 60 });
              });
            } else {
              //工作状态变更已驳回状态
              const list = this.idList.map(val => {
                return { ...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else {
            this.$message.error("当前状态不能再被审批");
          }
        } else {
          if (data.every(t => t.status == 35)) {
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, { workId: this.workId, status: 40, msgId: this.msgId, approveReason: this.approveReason }).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
                this.toWorkscorePage({ status: 40 });
              });
            } else {
              //工作状态变更已驳回状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, { workId: this.workId, status: 50, msgId: this.msgId, approveReason: this.rejectReason }).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else if (data.every(t => t.status == 55)) {
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, { workId: this.workId, status: 60, msgId: this.msgId, approveReason: this.approveReason }).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
                this.toWorkscorePage({ status: 60 });
              });
            } else {
              //工作状态变更已驳回状态
              this.$ajax.put(this.$api.year.yearWorkDetail.updateAllStatus, { workId: this.workId, status: 70, msgId: this.msgId, approveReason: this.rejectReason }).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else if (data.some(t => t.status == 35)) {
            this.idList = data.filter(t => t.status === 35).map(val => {
              const { id } = val;
              return { id: id, workId: this.workId };
            });
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              const list = this.idList.map(val => {
                return { ...val, status: 40, msgId: this.msgId, approveReason: this.approveReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
                this.toWorkscorePage({ status: 40 });
              });
            } else {
              //工作状态变更已驳回状态
              const list = this.idList.map(val => {
                return { ...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else if (data.some(t => t.status == 55)) {
            this.idList = data.filter(t => t.status === 55).map(val => {
              const { id } = val;
              return { id: id, workId: this.workId };
            });
            if (doWhat == 'access') {
              //工作状态变更已通过状态
              const list = this.idList.map(val => {
                return { ...val, status: 60, msgId: this.msgId, approveReason: this.approveReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
                this.toWorkscorePage({ status: 60 });
              });
            } else {
              //工作状态变更已驳回状态
              const list = this.idList.map(val => {
                return { ...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason };
              })
              this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
                this.$message.success('审批成功');
                this.editStatus = '';
                this.getList();
              });
            }
          } else {
            this.$message.error("当前状态不能再被审批");
          }
        }
      } else {
        if (checkData.every(t => t.status === 35)) {
          let data = check.filter(val => val.workId !== undefined);
          this.idList = data.map(val => {
            const { id } = val;
            return { id: id, workId: this.workId };
          });
          if (doWhat == 'access') {
            const list = this.idList.map(val => {
              return { ...val, status: 40, msgId: this.msgId, approveReason: this.approveReason };
            })
            //工作状态变更待审批状态
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
              this.$message.success('审批成功');
              this.getList().then(() => {
                const tableDataFlat = this.getAllChildrenRow(this.tableData);
                const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
                this.editStatus = this.judgeCompleteStatus(data) ? "" : 'approve';
              });
              this.toWorkscorePage({ status: 40 });
            });
          } else {
            const list = this.idList.map(val => {
              return { ...val, status: 50, msgId: this.msgId, approveReason: this.rejectReason };
            })
            //工作状态变更待审批状态
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
              this.$message.success('审批成功');
              this.getList().then(() => {
                const tableDataFlat = this.getAllChildrenRow(this.tableData);
                const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
                this.editStatus = this.judgeCompleteStatus(data) ? "" : 'approve';
              });
            });
          }
        } else if (checkData.every(t => t.status === 55)) {
          let data = check.filter(val => val.workId !== undefined);
          this.idList = data.map(val => {
            const { id } = val;
            return { id: id, workId: this.workId };
          });
          if (doWhat == 'access') {
            const list = this.idList.map(val => {
              return { ...val, status: 60, msgId: this.msgId, approveReason: this.approveReason };
            })
            //工作状态变更待审批状态
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
              this.$message.success('审批成功');
              this.getList().then(() => {
                const tableDataFlat = this.getAllChildrenRow(this.tableData);
                const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
                this.editStatus = this.judgeCompleteStatus(data) ? "" : 'approve';
              });
              this.toWorkscorePage({ status: 60 });
            });
          } else {
            const list = this.idList.map(val => {
              return { ...val, status: 70, msgId: this.msgId, approveReason: this.rejectReason };
            })
            //工作状态变更待审批状态
            this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, list).then(() => {
              this.$message.success('审批成功');
              this.getList().then(() => {
                const tableDataFlat = this.getAllChildrenRow(this.tableData);
                const data = tableDataFlat.filter(t => typeof t.id !== 'undefined');
                this.editStatus = this.judgeCompleteStatus(data) ? "" : 'approve';
              });
            });
          }
        } else {
          this.$message.error("当前状态不能再被审批");
        }
      }
    },
    judgeCompleteStatus(data){
      if (data.filter(t => t.status === 55 || t.status === 35 || t.status === 10).length){
        return false;
      }
      return true;
    },
    exportExcel() {
      let param = Object.assign({ WorkId: this.workId }, this.searchParam)
      this.$ajax.get(this.$api.year.yearWorkDetail.exportNext, param, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result;//内容就在这里
            let json = JSON.parse(content)
            this.$message.error(json.message)
          };
          reader.readAsText(res.data);
        } else {
          const filename = Object.keys(this.summaryData).length ? this.summaryData.title + '详情' + "(" + this.summaryData.resWkName + ")" : '年计划详情';
          const filetype = 'xlsx'
          let data = res.data;
          let url = window.URL.createObjectURL(data)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename + '.' + filetype
          a.click()
          window.URL.revokeObjectURL(url)
        }
      }).catch(() => { })
    },
    preciseExport() {
      this.dialogContent = {
        title: '精确导出',
        componentName: 'ExportNext',
        width: '950px',
      };
      this.editData.workId = this.workId;
      this.editData.year = this.summaryData.year;
      this.$refs.addSyncDialog.show();
    },
    downloadTemplate() {
      window.location.href = this.downloadUrl;
    },
    uploadFile({file}) {
      const params = new FormData();
      params.append('workId', this.workId);
      params.append('excelfile', file);
      this.$ajax.post(this.$api.year.yearWorkDetail.importNext, params, { headers: { 'Content-Type': 'multipart/form-data;' }}).then((res) => {
        if(res.code === 0){
          this.expandAll();
          this.$message.success('上传成功');
          this.getList();
        }
      });
    },
    expandSearch() {
      this.isShowSearch = !this.isShowSearch;
    },
    expandRowContentAll() {
      const tableDataFlat = this.getAllChildrenRow(this.tableData);
      if (this.expandRowContentAllFlag) {
        tableDataFlat.forEach(val => {
          if (val.workId){
            val.expandRowContentFlag = false;
          }
        }); 
      } else {
        tableDataFlat.forEach(val => {
          if (val.workId) {
            val.expandRowContentFlag = true;
          }
        });
      }
      this.expandRowContentAllFlag = !this.expandRowContentAllFlag;
      this.$refs.yearTable.updateData(this.tableData);

      this.$nextTick(() => {
        let scrollInfo = this.$refs.yearTable.getScroll();
        this.$refs.yearTable.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
      });
    },
    emptyChildrenExpandHandler(row) {
      row.emptyChildrenExpand = !row.emptyChildrenExpand;
    },
    handleCommand(command) {
      this.selecterData = this.$refs.yearTable.getCheckboxRecords().filter(val => val.workId !== undefined && !val.isClassifyRow);
      if (this.selecterData.length == 0) {
        this.$message.error('请先选择数据');
        return false;
      }
      this.dialogContent = {
        title: '批量操作',
        componentName: 'batchEdit',
        width: '450px',
        command: command
      };
      this.editData.workId = this.workId;
      this.$refs.addSyncDialog.show();
    },
    setRowClass({row}) {
      if (row.isClassifyRow) {
        return 'classify-row';
      }
    },
    selectSingle(row) {
      this.$refs.yearTable.toggleCheckboxRow(row);
    },
    checkboxVisible({row}) {
      // 已提交、分类的行不可勾选
      return this.status !== 10 && !row.isClassifyRow;
    },
    async addRow(row) {
      if (row.children.length >= row.limit) {
        this.$message.error(`最多可添加${row.limit}条数据`);
        return false;
      }
      const $table = this.$refs.yearTable;
      const newRecord = _.cloneDeep(this.newRow)
      newRecord.parentId = row.id;
      newRecord.type = row.type;
      newRecord.workClassify = row.workClassify;
      newRecord.id = 'temp_' + Date.now();
      newRecord.seq = `0.${row.children.length + 1}`
      const rowData = this.tableData.find(item => item.id === row.id);
      rowData.children.push(newRecord);
     
      let scrollInfo = $table.getScroll();
      await $table.loadData(this.tableData);
      $table.setActiveRow(newRecord);
      this.$nextTick(() => {
        $table.scrollTo(0, scrollInfo.scrollTop);
      });
    },
    
    editActived({ row }) {
      //审批状态
      if (this.editStatus == "approve") {
        if (row.status === 0) {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledHalfTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          this.enabled = true;
          this.enabledHalfTarget = true;
          this.enabledFhs = false;
          this.enabledFs = false;
        } else if (row.status === 10) {
          this.enabled = true;
          this.enabledHalfTarget = true;
          this.enabledWorkItemCategory = true;
          this.enabledExcep = true;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget = true;
        } else if (row.status === 20) {
          if (row.source === 0) {
            this.enabled = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledExcep = false;
            this.enabledFhs = false;
            this.enabledFs = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabled = false;
            this.enabledHalfTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledExcep = false;
            this.enabledFhs = false;
            this.enabledFs = false;
            this.enabledFinishFullTarget = false;
          }
        } else if (row.status === 30) {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledHalfTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          this.enabled = true;
          this.enabledFhs = false;
          this.enabledFs = false;
        } else if ([35, 40, 50, 70].includes(row.status)) {
          this.enabled = false;
          this.enabledFullTarget = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget = false;
        } else if (row.status === 55) {
          this.enabled = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget = false;
        } else if (row.status === 60) {
          this.enabled = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget = false;
        } else {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          this.enabled = true;
          this.enabledHalfTarget = true;
          this.enabledFhs = false;
          this.enabledFs = false;
        }
      } else if (this.editStatus == "edit") {
        //编辑状态
        if (row.status === 0) {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledHalfTarget = true;
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          this.enabled = true;
          this.enabledFhs = false;
          this.enabledFs = false;
        } else if ([10, 35, 55, 60].includes(row.status)) {
          this.enabled = false;
          this.enabledFullTarget = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = false;
          this.enabledFs = false;
          this.enabledFinishFullTarget = false;
        } else if (row.status === 30) {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledHalfTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          if (row.source === 0) {
            this.enabled = true;
            this.enabledHalfTarget = true;
            this.enabledFhs = false;
            this.enabledFs = false;
            this.enabledFinishFullTarget = true;
          } else {
            this.enabled = false;
            this.enabledHalfTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledExcep = false;
            this.enabledFhs = false;
            this.enabledFs = false;
            this.enabledFinishFullTarget = false;
          }
        } else if (row.status === 20) {
          if (row.source === 0) {
            this.enabled = false;
            this.enabledFullTarget = false;
            this.enabledHalfTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledExcep = false;
            this.enabledFhs = true;
            this.enabledFs = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabled = false;
            this.enabledFullTarget = false; //新增工作全年目标不能编辑  zyq
            this.enabledHalfTarget = true; //新增工作半年目标允许编辑  zyq
            this.enabledWorkItemCategory = true;
            this.enabledExcep = false;
            this.enabledFhs = true;
            this.enabledFs = false;
            this.enabledFinishFullTarget = false;
          }
        } else if (row.status === 50) {
          this.enabled = false;
          this.enabledFullTarget = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = true;
          this.enabledFs = false;
          this.enabledFinishFullTarget = false;
        } else if (row.status === 40 || row.status === 70) {
          this.enabled = false;
          this.enabledFullTarget = false;
          this.enabledHalfTarget = false;
          this.enabledWorkItemCategory = false;
          this.enabledExcep = false;
          this.enabledFhs = false;
          this.enabledFs = true;
          this.enabledFinishFullTarget = false;
        } else {
          if (row.type === 0) {
            this.enabledExcep = false;
            this.enabledFullTarget = false;
            this.enabledWorkItemCategory = false;
            this.enabledFinishFullTarget = false;
          } else {
            this.enabledExcep = true;
            this.enabledFullTarget = true;
            this.enabledWorkItemCategory = true;
            this.enabledFinishFullTarget = true;
          }
          this.enabled = true;
          this.enabledHalfTarget = true;
          this.enabledFhs = false;
          this.enabledFs = false;
        }
      } else {
        // 预览模式
        this.enabled = false;
        this.enabledFullTarget = false;
        this.enabledHalfTarget = false;
        this.enabledWorkItemCategory = false;
        this.enabledExcep = false;
        this.enabledFhs = false;
        this.enabledFs = false;
        this.enabledFinishFullTarget = false;

      }
      return true;
    },
    editClosed({row}) {
      
      this.enabled = true;
      this.enabledFullTarget = true;
      this.enabledHalfTarget = true;
      this.enabledWorkItemCategory = true;
      this.enabledExcep = true;
      this.enabledFhs = true;
      this.enabledFs = true;
      this.enabledFinishFullTarget = true;
      clearInterval(this.timer);
      if (row.id && !row.isClassifyRow) {
        if (
          (this.status === 0 && this.editStatus === "edit") ||
          (row.status === 10 && this.editStatus==="approve") ||
          (this.editStatus ==="edit" && [0, 20, 30, 40, 50, 70].includes(row.status))
        ) {
          if(this.$getRowExpandFlag()) row.expandRowContentFlag = false;
          this.$refs.yearTable.updateData(this.tableData);
          this.save(row);
        }
      }
    },
    activeRow({row}) {
      this.row = row;
      if ((this.row.status == 0 || this.row.status == 30) && this.editStatus == 'edit' && this.row.finishFullTarget == '') {
        this.$set(row, 'finishFullTarget', row.fullTarget);
      }
      clearInterval(this.timer);
      if ((this.status === 0 || this.status === 30 && this.editStatus==="edit") || (this.status === 10 && this.editStatus==="approve") || (this.editStatus==="edit"&&(row.status === 20 || row.status === 40 || row.status === 50 || row.status === 70))) {
        this.timer = setInterval(() => {
          this.saveAuto(row);
        }, 10000)
      }
    },
    querySearchWeight(_queryString, cb) {
      let weightList = [
        {"value": 5},
        {"value": 10},
        {"value": 15},
        {"value": 20},
        {"value": 25},
        {"value": 30}
      ];
      // 调用 callback 返回建议列表的数据
      cb(weightList);
    },
    async save(row) {
      if (this.autoSaving) {
        this.isPreventSave = true;
      } else {
        this.pending = true,
        row.status = row.status === null ? 0: row.status;
        const paramRow = _.cloneDeep(row);
        if (this.isTempId(paramRow.id)) {
          paramRow.id = undefined;
        }
        await this.$ajax.post(this.$api.year.yearWorkDetail.adu,  [paramRow], {noLoading: true}).then((res) => {
          const item = res.data instanceof Array? res.data[0]: {};
          item.expandRowContentFlag = row.expandRowContentFlag;
          // row.id = item.id;
          _.merge(row, item);
          // this.tableData.splice(index, 1, item);
          // this.$refs.yearTable.updateData(this.tableData);
          this.saveStatus = "已保存";
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = "";
          }, 1000, this);
          clearInterval(this.timer);
          this.$nextTick(() => {
            // this.setMerge();
          });
        }).finally(()=>{
          this.pending = false;
        });
      }
    },
    
    saveAll() {
      let saveData = [];
      this.tableData.forEach(item => {
        const childs = item.children.filter(val => {
          val.status === null ? 0: val.status;
          return val.workId !== undefined && val.status !== 35 && val.status !== 55 && val.status !== 60 && !val.isClassifyRow;
        });
        saveData.push(...childs)
      })
      const paramRows = _.cloneDeep(saveData);
      paramRows.forEach(item => {
        delete item._X_ID;
        if (this.isTempId(item.id)) {
          item.id = undefined;
        }
      })
      if(saveData.length === 0){
        return this.$message.warning('当前没有需要保存的数据');
      }
      this.$ajax.post(this.$api.year.yearWorkDetail.adu, paramRows).then((res) => {
        if(res.code == 0){
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
        }
      });
    },
    async saveAuto(row) {
      this.autoSaving = true;
      const weight = row.weight;
      row.weight = weight ? weight : 1;
      const paramRow = _.cloneDeep(row);
      if (this.isTempId(paramRow.id)) {
        paramRow.id = undefined;
      }
      await this.$ajax.post(this.$api.year.yearWorkDetail.adu, [paramRow], {noLoading: true}).then((res) => {
        const item = res.data && res.data[0];
        this.row = item;
        
        // this.tableData.splice(index, 1, item);
        _.merge(row, item);
        // row.id = item.id;
        // this.$refs.yearTable.updateData(this.tableData);
        this.saveStatus = "已保存";
        this.timeoutAutoSave && clearTimeout(this.timeoutAutoSave);
        this.timeoutAutoSave = setTimeout(() => {
          this.saveStatus = "";
        }, 1000, this);
        this.autoSaving = false;
        if (this.isPreventSave) {
          this.save(row);
        }
      }).catch(() => {
        this.autoSaving = false;
      });
    },
    expandThisRow(row) {
      row.emptyChildrenExpand = !row.emptyChildrenExpand;
      this.$refs.yearTable.toggleTreeExpand(row);
    },
    expandAll() {
      this.$refs.yearTable.setAllTreeExpand(true);
    },
    expandRowContent({row, column}) {
      if (column.type === 'checkbox' || column.title === 'NO.') {
        return false;
      }
      if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus === "approve")) {
        if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
        this.$refs.yearTable.updateData(this.tableData);
      } else {
        if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
        this.$refs.yearTable.updateData(this.tableData);
      }
      // this.$refs.yearTable.setTreeExpand(rows, checked)
    },
    moveClassify(row) {
      this.showHandle = true;
      this.nowClassify = row;
      this.classify = row.workClassify;
    },
    confirmClassify() {
      this.showHandle = false;
      this.$ajax.put(this.$api.year.yearWorkDetail.UpdateWorkClassify, {
        id: this.nowClassify.id,
        workClassify: this.classify,
      }).then(() => {
        this.getList();
        this.$message.success('更改工作分类成功');
      });
    },
    copyLast() {
      this.expandAll();
      this.getList();
    },
    commitComplete(row) {
      clearInterval(this.timer);
      this.saveAuto(row).then(async () => {
        const $table = this.$refs.yearTable;
        const errMap = await $table.validate(row).catch(errMap => errMap)
        if (errMap) {
          const msgList = []
          Object.values(errMap).forEach(errList => {
            errList.forEach(params => {
              // eslint-disable-next-line no-unused-vars
              const { rules } = params
              rules.forEach(rule => {
                // msgList.push(`第 ${rowIndex + 1} 行 ${column.title} 校验错误：${rule.message}`)
                msgList.push(`${rule.message}`)
              })
            })
          })
          this.$message({
            type: 'error',
            message: msgList.join()
          });
        } else {
          const status = (row.status == 20 || row.status == 50) ? 35 : 55;
          this.$ajax.put(this.$api.year.yearWorkDetail.updateStatus, [{
            id: row.id,
            workId: this.workId,
            status: status,
            msgId: this.msgId
          }]).then((res) => {
            if(res.code == 0) {
              this.$message.success('提交成功');
              this.getList();
            }
          });
        }
      })
    },
    complete(row, rowIndex, status) {
      this.approveRow = _.cloneDeep(row);
      this.$nextTick(()=>{
      if (status === "access") {
          this.approveReason = '';
          this.showApprove = true;
        } else {
          this.rejectReason = '';
          this.showCompleteApprove = true;
        }
      })
    },
    closeApprove() {
      this.approveReason = '';
      this.rejectReason = '';
      this.approveRow = null;
    },
    approveText(e) {
      this.approveReason = e;
    },
    rejectText(e) {
      this.rejectReason = e;
    },
    deleteData(row) {
      if (row.id && !this.isTempId(row.id)) {
        this.$ajax.delete(this.$api.year.yearWorkDetail.adu + '/' + row.id).then(() => {
          this.row = {};
          const currentParentRow = this.tableData.find(item => item.workClassify === row.workClassify);
          _.remove(currentParentRow.children || [], t => t.id == row.id);
          this.tableData.splice(0, 0)
          clearInterval(this.timer);
          this.$message.success('删除成功');
        });
      } else {
        const currentParentRow = this.tableData.find(item => item.workClassify === row.workClassify);
        
        _.remove(currentParentRow.children || [], t => t.id == row.id);
        currentParentRow.children.splice(0, 0);
        clearInterval(this.timer);
        this.$message.success('删除成功');
      }
    },
    // 列隐藏展示切换
    columnHideToggle(d) {
      let val = this.tableColumn.find(row => row.id == d.id)
      if (val) {
        val.visible = !val.visible
        this.$refs.yearTable && this.$refs.yearTable.refreshColumn();
        if (this.editStatus === "edit" && this.model == "1") {
          localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
        }
        setTimeout(() => {
          this.setPosition(null);
        }, 50);
      }
    },
    isTempId(id = '') {
      return id.includes('temp_');
    },
    toWorkscorePage({status}) {
      const param = {
        wkNo: this.summaryData.resWkNo,
        wkName: this.summaryData.resWkName,
        year: this.summaryData.year,
        period: status === 40 ? 6.5 : 13,
        status,
        workId: this.summaryData.id,
        approveReason: this.approveReason,
      };
      this.$ajax.post(this.$api.period.workScore.canJump, param, {ignore: true}).then(res => {
        if (res.data.code === 0) {
          this.$router.push({
            path: '/personal/workscore/yearDetailNext',
            query: {
              id: res.data.data.data.id,
              editStatus: 'approve'
            },
          });
        }
      });
    }
  },
  created() {
    this.workId = this.$route.query.id || '';
    this.status = parseInt(this.$route.query.status) || 0;
    this.editStatus = this.$route.query.editStatus || '';
    this.newRow.workId = this.workId;
    this.msgId = this.$route.query.msgId || null;
    this.childIds = this.$route.query.childIds ? this.$route.query.childIds.split(',') : null;
    this.fromPage = this.$route.query.fromPage || '';
    this.getCategory();
    this.getWorkItemStatus().then(() => {
      this.workId && this.getList().then(() => {
        this.getMinLimit();
        this.getNoMinLimitByDept();
      });
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.tableColumn = this.$refs.yearTable.getColumns();
      if(localStorage.getItem("year_table_herder") && this.editStatus === "edit" && this.model == "1"){
        let cache = JSON.parse(localStorage.getItem("year_table_herder"));
        this.tableColumn.forEach(v => {
          cache.forEach(t => {
            if (v.title == t.title) {
              v.visible = t.visible;
            }
          })
        })
        this.$refs.yearTable && this.$refs.yearTable.refreshColumn();
      } else {
        if(this.editStatus === "edit") {
          localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
        }
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>
<style lang="scss" scoped>
  .year-next {
    height: 100%;
    .header {
      .year-title {
        border-right: 1px solid #eaeef4;
        padding: 0 10px;
        .title-text {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .save-status {
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
    }
    .container {
      margin-top: 15px;
      padding: 0 20px 20px;
      flex: 1;
      .el-icon-arrow-down {
        font-size: 12px;
      }
      .open {
        position: absolute;
        right: 0;
        top: 24px;
        text-align: right;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
      .table-content {
        position: relative;
        .collapse {
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          &:hover {
            background-color: rgba(#000, 0.2);
          }
          i {
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .search {
        position: relative;
        padding-top: 12px;
        padding-right: 56px;
        overflow: auto;
        .function {
          flex-wrap: wrap;
          align-items: center;
        }
        .atb-input {
          display: flex;
          .flex-form-item {
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode {
            align-self: flex-end;
          }
          ::v-deep.el-form-item__label {
            white-space: nowrap;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            line-height: 1;
            .el-select, .el-autocomplete {
              width: 100%;
            }
          }
        }
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        user-select: text;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
      }
      ::v-deep .classify-row {
        padding-left: 8px;
        background-color: $--color-bg-table-header;
        .vxe-cell--placeholder {
          font-size: 0;
        }
        .vxe-cell--checkbox, .vxe-cell {
          padding: 0;
        }
        .vxe-body--column {
          background-image: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff)
        }
      }
      .vxe-tree-cell {
        padding: 0;
      }
      ::v-deep .vxe-tree--node-btn {
        color: $--color-primary;
      }
      ::v-deep .vxe-tree--btn-wrapper {
        left: 8px;
        top: 42%;
      }
      .row-add {
        height: 46px;
        color: $--color-primary;
        font-size: 14px;
        .classify-wrap {
          margin-left: 10px;
          cursor: pointer;
          .classify-name {
            margin-right: 15px;
          }
        }
        .empty-children-expand-icon {
          position: absolute;
          left: -23px;
          top: -1px;
        }
        .classify-name {
          position: relative;
          user-select: none;
          cursor: pointer;
        }
        .add-btn {
          margin-right: 15px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-tag {
      padding: 0 10px;
      width: auto;
      text-align: center;
    }
    ::v-deep .vxe-cell {
      padding: 0 5px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
    .el-button--import {
      border-color: #def6e8;
      color: #0dcc82;
    }
    ::v-deep .el-button--downloadTemplate {
      width: 100px !important;
      background-color: #def6e8;
      border-color: #def6e8;
      color: #0dcc82;
    }
    ::v-deep .el-radio-button {
      margin-right: 20px;
      margin-bottom: 15px;
      .el-radio-button__inner {
        border-radius: 20px;
        padding: 0 20px;
        width: 100%;
        line-height: 36px;
        border: 1px solid $--color-primary;
        color: $--color-primary;
      }
    }
    ::v-deep .el-radio-button.is-active .el-radio-button__inner {
      color: $--color-white;
    }
    .submit-limit-tip {
      ::v-deep .el-dialog__body {
        padding-top: 16px!important;
      }
      .submit-limit-icon {
        color: #d9b974;
        font-size: 40px;
      }
      h2 {
        margin: 10px 0;
        font-weight: normal;
        font-size: 16px;
      }
      .submit-tip-wrap {
        margin-bottom: 10px;
        padding: 10px;
        background-color: #f6f8fa;
        border-radius: 2px;
      }
      .submit-tip-content {
        text-align: left;
        font-weight: bold;
        line-height: 1.5;
      }
      .submit-tip-item {
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

  }
</style>